export enum ReservationType {
  ChargingParking = 1,
  FastChargingParking = 2,
}
